import { render, staticRenderFns } from "./ColorMenu.vue?vue&type=template&id=44c85867&scoped=true&"
import script from "./ColorMenu.vue?vue&type=script&lang=js&"
export * from "./ColorMenu.vue?vue&type=script&lang=js&"
import style0 from "./ColorMenu.vue?vue&type=style&index=0&id=44c85867&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c85867",
  null
  
)

export default component.exports